
import {decode }from 'html-entities'
// import SsrCarousel from 'vue-ssr-carousel'
// eslint-disable-next-line no-unused-vars
// import ssrCarouselCss from 'vue-ssr-carousel/index.css'
import { mapGetters,mapActions } from 'vuex'
import productData from '@/data/products.json'
import reviewData from '@/data/reviews.json'
// import optionsData from '@/data/options.json';
export default {
  // components: { SsrCarousel },
  async asyncData({ $page, store, route }) {
    if ($page) return { page: $page }
    else return { page: await store.dispatch('pages/getPage', route.fullPath) }
  },
    data(){
      return{
        // FAQModalShow:
        productIds: ['25','10183', '26', '10184', '18', '19', '27', '10185',  '10183', '10184', '10185', '10189', '10192', '10191', '10189', '10179', '105', '106', '10161', '1', '8'],
        reviews: reviewData,
      }
    },
    head() {
        const title = this.page.seo.fullHead.child
        .map((el) => (el.tag === 'title' ? el.child[0].text : null))
        .filter((el) => el)[0]
        const metas = this.page.seo.fullHead.child.filter(
            (tag) => tag.node === 'element'
        )
        const metasArray = metas.filter((m) => m.tag === 'meta').map((m) => m.attr)
        const linkArray = metas.filter((m) => m.tag === 'link').map((m) => m.attr)
        const scriptArray = metas.filter((m) => m.tag === 'script')
        const meta = []
        const link = []
        const script = []

        if(process.env.ROBOTS === 'LIVE'){
          metasArray.push({name:'robots', content:'index, follow'})
        } else {
          metasArray.push({name:'robots', content:'noindex, nofollow'})
        }

        for (let i = 0; i < metasArray.length; i++) {
            const obj = {}
            if (metasArray[i].name) obj.name = metasArray[i].name
            if (metasArray[i].property) obj.property = metasArray[i].property
            obj.content =
                typeof metasArray[i].content === 'string'
                ? metasArray[i].content.replace(
                    /(?<!\w-)\b\w+\.tefl\.org\b/g,
                    'www.tefl.org'
                    )
                : metasArray[i].content.join(' ')

            meta.push(obj)
        }
        for (let i = 0; i < linkArray.length; i++) {
            const obj = {}
            obj.rel = linkArray[i].rel
            obj.href = linkArray[i].href.replace(
                /(?<!\w-)\b\w+\.tefl\.org\b/g,
                'www.tefl.org'
            )

            link.push(obj)
            link.push({rel:"alternate",hreflang:'en',href:"https://www.tefl.org/courses/"})
            link.push({rel:"alternate",hreflang:'x-default',href:"https://www.tefl.org/courses/"})
            link.push({rel:"alternate",hreflang:'en-US',href:"https://www.tefl.org/en-us/courses/"})
        }
        for (let i = 0; i < scriptArray.length; i++) {
            const obj = {}
            obj.class = scriptArray[i].attr.class
            obj.type = scriptArray[i].attr.type
            obj.innerHTML = `${scriptArray[i].child[0].text.replace(
                /(?<!\w-)\b\w+\.tefl\.org\b/g,
                'www.tefl.org'
            )}`
            script.push(obj)
        }
        script.push({type:'application/ld+json', json: this.structuredData})
        return {
            /* eslint-disable */
            title: decode(title),
            meta: meta,
            link: link,
            script: script,
            __dangerouslyDisableSanitizers: ['script'],
            /* eslint-enable */
        }
    },
    computed: {
      ...mapGetters({
        activeModal : 'pages/getActiveModal',
        regionClicked : 'cart/getRegionClicked'
      }),
      products() {
        const products = this.productIds.map((id) => {return productData.find((product) => {return product.id.toString() === id})})
        return products
      },
      priceData() {
        const priceDataArray = []
        this.products.forEach((product) => {
          const priceD = this.$options.filters.priceData(product)
          priceDataArray.push(priceD)
        })
        return priceDataArray
      },
      prices(){
          const prices = []
          this.priceData.forEach((priceData) => {
            const price = this.$nuxt.$options.filters.priceFromLabelNumber(priceData.pricesDiscounted)
            prices.push(price)
          })
          return prices
        },
      currency(){
          const currency = this.$nuxt.$options.filters.currencyCodeFromLabel()
          return currency
        },
      modes(){
        const modesList = []
        this.products.forEach((product) => {
          let mode;
          if (product.type === "combined course") {
            mode = "Blended"
          }
          else if (product.type === "classroom course") {
            mode = "Onsite"
          }
          else {
            mode = "Online"
          }
          modesList.push(mode)
        })
        return modesList
      },
      // itemsList() {
      //   const itemList = []

      //       this.products.forEach((product, index) => {
      //         const description = this.limit(product.description, 56)
      //        itemList.push({
      //         "@type": "ListItem",
      //         "position": (index + 1),
      //         "item": {
      //         "@type": "Course",
      //         "name": product.name,
      //         "image": product.page.en.thumbnail,
      //         "url": "https://www.tefl.org"+product.page.en.uri,
      //         description,
      //         "offers": {
      //         "@type": "Offer",
      //         "price": this.prices[index].toString(),
      //         "priceCurrency": this.currency
      //         },
      //         "provider": {
      //         "@id": "https://www.tefl.org/#educationalorganization",
      //         "name": "The TEFL Org"
      //         },
      //         }
      //         })
      //       })
      //       return itemList
      // },
      structuredData() {
        const averageRating = this.$nuxt.$options.filters.roundScore(Number(this.reviews.stats.company.average_rating))
        const ratingCount = this.reviews.stats.company.review_count
        return {
          "@context": "https://schema.org/",
          "@type": "ItemList",
          "itemListElement":
          [
            {
              "position": "1",
              "@type": "Course",
              "name": "120-Hour Premier Online TEFL Course",
              "image": "https://www.tefl.org/_nuxt/images/120-hour-premier-min-74dc2b.webp",
              "url": "https://www.tefl.org/courses/online/120-hour-premier-online-tefl-course/",
              "description": this.limit("Our best-selling 120-hour Premier Online TEFL course covers everything you need to get your first job teaching English. Get to grips with English grammar, learn about different teaching methodologies, how to plan engaging lessons, and much, much more.",57),
              "offers": {
                "@type": "Offer",
                "category": "Paid",
                "price": this.prices[0].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[0] ],
                "courseWorkload": "PT"+this.products[0].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
            },
              "about": "Teaching English as a Foreign Language",
              "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": averageRating,
              ratingCount,
              "bestRating": 5
            },
            },
            {
              "position": "2",
              "@type": "Course",
              "name": "200-hour Level 5 TEFL Diploma",
              "image": "https://www.tefl.org/_nuxt/images/200hr-edit-1b3a39.webp",
              "url": "https://www.tefl.org/courses/level-5/200-hour-online-level-5-tefl-course/",
              "description": this.limit("Offering more comprehensive training, our 200-hour Level 5 TEFL Diploma is a great option for those who would benefit from giving their CV a boost. Don’t have a degree? Not a native English speaker? No previous teaching experience? We’d recommend this Level 5 Diploma!",57),
              "offers": {
                "@type": "Offer",
                "category": "Paid",
                "price": this.prices[1].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[1] ],
                "courseWorkload": "PT"+this.products[1].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "3",
              "@type": "Course",
              "name": "140-hour Premier TEFL Course",
              "image": "https://www.tefl.org/_nuxt/images/140-hour-TEFL-min-4c93b3.webp",
              "url": "https://www.tefl.org/courses/combined/140-hour-premier-tefl-course/",
              "description": this.limit("This course includes everything you’ll find in our best-selling 120-hour Premier Online course and a 20-hour weekend classroom course. With classroom locations across the UK and Ireland, as well as the option to complete it at home virtually, there are options to suit everyone.",57),
              "offers": {
                "@type": "Offer",
                "category": "Paid",
                "price": this.prices[2].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[2] ],
                "courseWorkload": "PT"+this.products[2].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "4",
              "@type": "Course",
              "name": "220-hour Level 5 TEFL Diploma",
              "image": "https://www.tefl.org/_nuxt/images/220-hour-diploma-min-a38742.webp",
              "url": "https://www.tefl.org/courses/level-5/220-hour-level-5-tefl-course/",
              "description": this.limit("Combine our popular 200-hour Level 5 TEFL Diploma with a 20-hour classroom course. A great option for anyone looking for comprehensive TEFL training that will boost both CV and confidence.",57),
              "offers": {
                "@type": "Offer",
                "category": "Paid",
                "price": this.prices[3].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[3] ],
                "courseWorkload": "PT"+this.products[3].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "5",
              "@type": "Course",
              "name": "120-hour TEFL Course",
              "image": "https://www.tefl.org/_nuxt/images/120-hour-TEFL-min-4675cb.webp",
              "url": "https://www.tefl.org/courses/combined/120-hour-tefl-course/",
              "description": this.limit("Our basic combined course, the 120-hour TEFL course includes 100 hours of self-paced online study and a 20-hour weekend classroom course. Complete your classroom course in person at one of our UK and Ireland locations, or virtually over Zoom.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[4].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[4] ],
                "courseWorkload": "PT"+this.products[4].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "6",
              "@type": "Course",
              "name": "130-hour TEFL Course",
              "image": "https://www.tefl.org/_nuxt/images/130-hr-tefl-2bea0f.webp",
              "url": "https://www.tefl.org/courses/combined/130-hour-tefl-course/",
              "description": this.limit("Combine 100 hours of self-paced online study with a 30-hour weekday classroom course. Complete your classroom course in person at one of our UK and Ireland locations, or virtually over Zoom.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[5].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[5] ],
                "courseWorkload": "PT"+this.products[5].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "7",
              "@type": "Course",
              "name": "150-hour Premier TEFL Course",
              "image": "https://www.tefl.org/_nuxt/images/150-hour-TEFL-min-e17752.webp",
              "url": "https://www.tefl.org/courses/combined/150-hour-premier-tefl-course/",
              "description": this.limit("Prefer to complete your classroom training during the week? This course combines our best-selling 120-hour Premier Online course with a 30-hour weekday classroom course. Complete your classroom course in person or virtually.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[6].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[6] ],
                "courseWorkload": "PT"+this.products[6].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "8",
              "@type": "Course",
              "name": "230-hour Level 5 TEFL Diploma",
              "image": "https://www.tefl.org/_nuxt/images/230-hour-diploma-min-22741f.webp",
              "url": "https://www.tefl.org/courses/level-5/230-hour-level-5-tefl-course/",
              "description": this.limit("Complete your classroom training during the week, with our 230-hour Level 5 TEFL Diploma. Combining our 200-hour Level 5 TEFL Diploma, which you’ll complete online, with a 30-hour weekday classroom course held either in person or virtually.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[7].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[7] ],
                "courseWorkload": "PT"+this.products[7].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "9",
              "@type": "Course",
              "name": "200-hour Level 5 TEFL Diploma",
              "image": "https://www.tefl.org/_nuxt/images/200hr-edit-1b3a39.webp",
              "url": "https://www.tefl.org/courses/level-5/200-hour-online-level-5-tefl-course/",
              "description": this.limit("Offering more comprehensive training, our 200-hour Level 5 TEFL Diploma is a great option for those who would benefit from giving their CV a boost. Don’t have a degree? Not a native English speaker? No previous teaching experience? We’d recommend this Level 5 Diploma!",57),
              "@id": "https://www.tefl.org/courses/#mainentity",
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[8].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[8] ],
                "courseWorkload": "PT"+this.products[8].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "10",
              "@type": "Course",
              "name": "220-hour Level 5 TEFL Diploma",
              "image": "https://www.tefl.org/_nuxt/images/220-hour-diploma-min-a38742.webp",
              "url": "https://www.tefl.org/courses/level-5/220-hour-level-5-tefl-course/",
              "description": this.limit("Combine our popular 200-hour Level 5 TEFL Diploma with a 20-hour classroom course. A great option for anyone looking for comprehensive TEFL training that will boost both CV and confidence.",57),
              "offers": {
                "@type": "Offer",
                "category": "Paid",
                "price": this.prices[9].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[9] ],
                "courseWorkload": "PT"+this.products[9].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "11",
              "@type": "Course",
              "name": "230-hour Level 5 TEFL Diploma",
              "image": "https://www.tefl.org/_nuxt/images/230-hour-diploma-min-22741f.webp",
              "url": "https://www.tefl.org/courses/level-5/230-hour-level-5-tefl-course/",
              "description": this.limit("Complete your classroom training during the week, with our 230-hour Level 5 TEFL Diploma. Combining our 200-hour Level 5 TEFL Diploma, which you’ll complete online, with a 30-hour weekday classroom course held either in person or virtually.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[10].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[10] ],
                "courseWorkload": "PT"+this.products[10].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "12",
              "@type": "Course",
              "name": "Observed Teaching Practice",
              "image": "https://cdn-wp.tefl.org/wp-content/uploads/2024/07/Observed-Teaching-Practice-Image-small.jpg",
              "url": "https://www.tefl.org/courses/advanced/40-hour-observed-teaching-practice/",
              "description": this.limit("Improve your skills in lesson planning and delivery and gain valuable feedback from an experienced EFL teacher with this advanced TEFL course. A great option for newly-qualified and experienced teachers alike!", 57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[11].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[11] ],
                "courseWorkload": "PT"+this.products[11].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "13",
              "@type": "Course",
              "name": "Teaching English Online",
              "image": "https://www.tefl.org/_nuxt/images/TEO-min-28a91b.webp",
              "url": "https://www.tefl.org/courses/advanced/40-hour-teaching-english-online/",
              "description": this.limit("Become an online English teacher and work from home - or wherever there’s an internet connection! - with our Teaching English Online course. Learn how to conduct effective online lessons, as well as how to promote yourself and find students.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[12].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[12] ],
                "courseWorkload": "PT"+this.products[12].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "14",
              "@type": "Course",
              "name": "Teaching English for Academic Purposes",
              "image": "https://www.tefl.org/_nuxt/images/TEO-min-28a91b.webp",
              "url": "https://www.tefl.org/courses/advanced/40-hour-teaching-english-for-academic-purposes/",
              "description": this.limit("Become certified to teach English for Academic Purposes (EAP) lessons with this Advanced TEFL course. Work with some of the millions of learners worldwide applying for, or already studying at, English-speaking universities.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[13].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[13] ],
                "courseWorkload": "PT"+this.products[13].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },

            {
              "position": "15",
              "@type": "Course",
              "name": "Teaching Exam Preparation Classes course",
              "image": "https://www.tefl.org/_nuxt/images/TEO-min-28a91b.webp",
              "url": "https://www.tefl.org/courses/advanced/40-hour-teaching-exam-preparation-classes/",
              "description": this.limit("Millions sit English language proficiency exams every single year. Tap into this huge market with our Teaching Exam Preparation Classes course and learn how to prepare students for a range of popular exams, such as the IELTS and TOEFL.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[14].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
                "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[14] ],
                "courseWorkload": "PT"+this.products[14].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "16",
              "@type": "Course",
              "name": "Teaching Young Learners",
              "image": "https://www.tefl.org/_nuxt/images/TYL-min-ebd3e1.webp",
              "url": "https://www.tefl.org/courses/advanced/30-hour-teaching-young-learners/",
              "description": this.limit("Our Teaching Young Learners course is a must for anyone aiming to work with children up to the age of 10. Understand how to make learning fun for young learners and keep them engaged with tried and tested techniques.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[15].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[15] ],
                "courseWorkload": "PT"+this.products[15].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "17",
              "@type": "Course",
              "name": "Business English",
              "image": "https://www.tefl.org/_nuxt/images/TBE-min-e0b115.webp",
              "url": "https://www.tefl.org/courses/advanced/30-hour-teaching-business-english/",
              "description": this.limit("Break into the lucrative world of Business English with this course developed by expert EFL teachers. In this course, you’ll learn how to develop lessons tailored to the specific needs and goals of business people worldwide.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[16].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[16] ],
                "courseWorkload": "PT"+this.products[16].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "18",
              "@type": "Course",
              "name": "Online Teaching Practice",
              "image": "https://www.tefl.org/_nuxt/images/OTP-min-323f15.webp",
              "url": "https://www.tefl.org/courses/advanced/online-teaching-practice/",
              "description": this.limit("Get practical experience teaching English online with our Online Teaching Practice. Held over Zoom, you’ll get to grips with delivering online lessons and practice delivering your own in front of a tutor and your peers.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[17].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[17] ],
                "courseWorkload": "PT"+this.products[17].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "19",
              "@type": "Course",
              "name": "20-hour Weekend Classroom TEFL Course",
              "image": "https://www.tefl.org/_nuxt/images/20-hour-min-f4b2dd.webp",
              "url": "https://www.tefl.org/courses/classroom/20-hour-weekend-tefl-course/",
              "description": this.limit("Learn how to teach English from a highly qualified and experienced EFL tutor. Complete this course at one of our UK or Ireland locations, or do it from home virtually over Zoom. Both options cover the same syllabus.",57),
              "offers": {
                "@ype": "offer",
                "category": "Paid",
                "price": this.prices[18].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[18] ],
                "courseWorkload": "PT"+this.products[18].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            },
            {
              "position": "20",
              "@type": "Course",
              "name": "30-hour Weekday Classroom TEFL Course",
              "image": "https://www.tefl.org/_nuxt/images/30-hour-min-378786.webp",
              "url": "https://www.tefl.org/courses/classroom/30-hour-weekday-tefl-course/",
              "description": this.limit("This course allows you to complete your classroom training during the week and has the benefit of additional teaching practices. Complete it in person at a location of your choosing, or virtually over Zoom.",57),
              "offers": {
                "@type": "offer",
                "category": "Paid",
                "price": this.prices[19].toString(),
                "priceCurrency": this.currency,
                "availability": "https://schema.org/InStock",
              },
              "provider": {
                "@id": "https://www.tefl.org/#educationalorganization",
                "@type": "Organization",
                "name": "The TEFL Org",
                "url": "https://www.tefl.org/"
              },
              "hasCourseInstance": {
                "@type": "CourseInstance",
                "courseMode": [ this.modes[19] ],
                "courseWorkload": "PT"+this.products[19].course.hours.toString()+"H"
              },
              "inLanguage": "en",
              "interactivityType": "active",
              "isAccessibleForFree": false,
              "audience": {
              "@type": "Audience",
              "educationalCredentialAAwarded": {
                "@type": "EducationalOccupationalCredential",
                "name": "Tefl Org Certificate",
                "credentialCategory": "Certificate",
                "url": "https://www.tefl.org/about-us/accreditation/",
              },
              "audienceType": [
                "People who are serious about teaching English as a foreign language.",
                "Those who are interested in the opportunity to work in most countries in the world.",
                "Professionals who want to re-educate themselves.",
                "Students who are considering a gap year.",
                "Anyone who would like a career teaching online."
              ]
              },
                "about": "Teaching English as a Foreign Language",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": averageRating,
                ratingCount,
                "bestRating": 5
              },
            }
          ]
        }
      },
    },
    methods:{
        ...mapActions({
          updateActiveModal: 'pages/updateActiveModal',
        }),
        updateModal(id){
          this.updateActiveModal(id)
          console.log('Active Modal: ',this.activeModal)
        },
        limit(string, limit){
          return string.substring(0, limit)+"..."
        }
    },
}
